/* Tiloa Analytics — couche de mesure first-party.

   Ce fichier ne dépend d'aucun service extérieur. Il observe, normalise et met
   en file des événements ; il ne les envoie que si un point de collecte a été
   configuré ET si la personne a accepté la mesure. Sans point de collecte, il
   ne fait rien d'autre que remplir une file en mémoire — aucune requête, aucun
   stockage. C'est volontaire : la boutique doit rester intacte tant que
   l'infrastructure n'est pas déployée.

   TROIS RÈGLES QUI NE SE NÉGOCIENT PAS
   1. Le consentement commande. Tant que la mesure n'est pas acceptée, rien
      n'est écrit sur le poste de la personne et rien n'est envoyé. Un refus
      efface ce qui aurait pu être mis en attente.
   2. Rien ne doit casser. Tout est sous try/catch, tout est asynchrone, et
      aucun écouteur n'annule un geste de l'utilisateur. Une erreur ici ne doit
      jamais empêcher un ajout au panier.
   3. Aucune donnée sensible. Ni contenu de champ, ni adresse, ni moyen de
      paiement, ni identité. Les identifiants sont anonymes et générés ici.

   CE QU'IL NE FAIT PAS
   Il ne mesure pas le checkout : les pages de paiement Shopify n'exécutent pas
   les scripts du thème. Cette partie passe par un Custom Pixel Shopify, dont
   le code est fourni dans ANALYTICS.md.
*/
(function () {
  'use strict';

  var CFG = window.TILOA_ANALYTICS_CONFIG || {};
  var ENDPOINT = CFG.endpoint || '';
  var VERSION = '1.0.0';

  /* ---------------------------------------------------------------------
     Outils de base — tous silencieux en cas d'échec
     --------------------------------------------------------------------- */

  function sansEchec(fn, secours) {
    try { return fn(); } catch (e) { return secours; }
  }

  function uuid() {
    return sansEchec(function () {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
      var b = new Uint8Array(16);
      window.crypto.getRandomValues(b);
      b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80;
      var h = [];
      for (var i = 0; i < 16; i++) h.push((b[i] + 0x100).toString(16).slice(1));
      return h.slice(0, 4).join('') + '-' + h.slice(4, 6).join('') + '-' + h.slice(6, 8).join('') +
             '-' + h.slice(8, 10).join('') + '-' + h.slice(10).join('');
    }, 'x' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
  }

  var LS = {
    lire: function (k) { return sansEchec(function () { return window.localStorage.getItem(k); }, null); },
    ecrire: function (k, v) { sansEchec(function () { window.localStorage.setItem(k, v); }); },
    effacer: function (k) { sansEchec(function () { window.localStorage.removeItem(k); }); },
  };
  var SS = {
    lire: function (k) { return sansEchec(function () { return window.sessionStorage.getItem(k); }, null); },
    ecrire: function (k, v) { sansEchec(function () { window.sessionStorage.setItem(k, v); }); },
  };

  var DEBUG = sansEchec(function () {
    if (/[?&]analytics_debug=true/i.test(window.location.search)) {
      window.sessionStorage.setItem('tiloa_debug', '1');
      return true;
    }
    return window.sessionStorage.getItem('tiloa_debug') === '1';
  }, false);

  function trace() {
    if (!DEBUG) return;
    var a = ['%c[TILOA ANALYTICS]', 'color:#111;background:#FFC700;padding:1px 5px;border-radius:3px'];
    for (var i = 0; i < arguments.length; i++) a.push(arguments[i]);
    sansEchec(function () { console.log.apply(console, a); });
  }

  /* ---------------------------------------------------------------------
     Trafic à écarter — repéré, jamais supprimé en silence
     ---------------------------------------------------------------------
     On ne prétend pas reconnaître un robot à coup sûr. On pose un drapeau que
     le rapport pourra filtrer, et on dit pourquoi il a été posé. */

  /* Classement d'une visite.

     On ne cherche pas a deviner : on additionne des signaux, chacun avec sa
     force. Un agent declarant « bot » est une certitude ; une navigation un
     peu rapide n'en est pas une. Rien n'est jamais supprime, seulement
     etiquete, et la raison voyage avec l'evenement pour que la decision
     reste auditable. */

  var CATEGORIES = {
    HUMAIN: 'real_human',
    INTERNE: 'owner_internal_test',
    BOT: 'bot_automated',
    INCERTAIN: 'unknown',
  };

  /* Marqueur du navigateur du proprietaire.
     Deux supports volontairement : le stockage local et un cookie premier
     niveau. Vider les cookies ou vider le stockage arrive souvent quand on
     teste ; perdre le marqueur a ce moment-la est exactement le pire moment,
     parce qu'on enchaine alors des ajouts au panier et des checkouts de test
     qui entrent dans les chiffres commerciaux.
     Ce n'est pas du fingerprinting : c'est un marqueur explicite, pose a la
     demande, visible, et retire par une URL tout aussi simple. */
  var COOKIE_INTERNE = 'tiloa_internal_test';
  var COOKIE_SESSION_TEST = 'tiloa_test_session';

  function lireCookie(nom) {
    return sansEchec(function () {
      var m = document.cookie.match(new RegExp('(?:^|; )' + nom + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    }, null);
  }
  function ecrireCookie(nom, valeur, jours) {
    sansEchec(function () {
      var exp = new Date(Date.now() + jours * 864e5).toUTCString();
      document.cookie = nom + '=' + encodeURIComponent(valeur) + '; expires=' + exp +
                        '; path=/; SameSite=Lax';
    });
  }
  function effacerCookie(nom) {
    sansEchec(function () {
      document.cookie = nom + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax';
    });
  }

  function armerInterne(actif) {
    if (actif) { LS.ecrire(COOKIE_INTERNE, '1'); ecrireCookie(COOKIE_INTERNE, '1', 365); }
    else { LS.effacer(COOKIE_INTERNE); effacerCookie(COOKIE_INTERNE); effacerCookie(COOKIE_SESSION_TEST); }
    return actif;
  }

  function marqueurInterne() {
    // ?tiloa_test=1 arme le mode proprietaire, ?tiloa_test=0 le leve.
    // ?tiloa_test_session=start marque une campagne de test nommee, utile
    // quand on va enchainer panier, checkout et paiement pour verifier le
    // tunnel : tout ce bloc est ecarte des chiffres commerciaux d'un coup.
    return sansEchec(function () {
      var q = new URLSearchParams(window.location.search);

      var ts = q.get('tiloa_test_session');
      if (ts === 'start') { armerInterne(true); ecrireCookie(COOKIE_SESSION_TEST, String(Date.now()), 1); }
      else if (ts === 'end') { effacerCookie(COOKIE_SESSION_TEST); }

      var v = q.get('tiloa_test');
      if (v === null) v = q.get('tiloa_owner');   // ancien nom, conserve
      if (v === '1' || v === 'true') return armerInterne(true);
      if (v === '0' || v === 'false') return armerInterne(false);

      return LS.lire(COOKIE_INTERNE) === '1' || lireCookie(COOKIE_INTERNE) === '1';
    }, false);
  }

  function typeDeTrafic() {
    var signaux = [];
    var poidsBot = 0;

    sansEchec(function () {
      var h = window.location.hostname;
      var q = window.location.search;

      // --- signaux internes, certitude totale ---
      if (marqueurInterne())                 signaux.push(['marqueur_tiloa_test', 'interne', 'HIGH']);
      if (window.Shopify && window.Shopify.designMode) signaux.push(['editeur_de_theme', 'interne', 'HIGH']);
      if (/[?&]preview_theme_id=/.test(q))   signaux.push(['previsualisation_de_theme', 'interne', 'HIGH']);
      if (/[?&]_ab=|[?&]_fd=|[?&]_sc=/.test(q)) signaux.push(['apercu_shopify', 'interne', 'HIGH']);
      if (/^(localhost|127.0.0.1)$/.test(h)) signaux.push(['hote_local', 'interne', 'HIGH']);
      if (/.myshopify.com$/.test(h))       signaux.push(['domaine_technique', 'interne', 'HIGH']);

      // --- signaux d'automatisation ---
      if (navigator.webdriver) { signaux.push(['navigateur_pilote', 'bot', 'HIGH']); poidsBot += 3; }
      if (/bot|crawl|spider|slurp|headless|lighthouse|pagespeed|monitor|preview|scrape/i.test(navigator.userAgent)) {
        signaux.push(['agent_declare_automatise', 'bot', 'HIGH']); poidsBot += 3;
      }
      // Indices faibles : chacun seul ne prouve rien.
      // « Aucun plugin » ne veut rien dire sur mobile : Chrome Android renvoie
      // toujours une liste vide, et les navigateurs integres aux applications
      // aussi. Compter ce signal revenait a marquer suspect chaque visiteur
      // venu de l'application Pinterest — c'est-a-dire l'essentiel du trafic
      // paye. Observe en production le 29 septembre sur une vraie session.
      var surBureau = sansEchec(function () {
        return !('ontouchstart' in window) && (window.screen ? window.screen.width >= 1024 : false);
      }, false);
      if (surBureau && navigator.plugins && navigator.plugins.length === 0) { signaux.push(['aucun_plugin', 'bot', 'LOW']); poidsBot += 1; }
      if (!navigator.languages || !navigator.languages.length) { signaux.push(['aucune_langue', 'bot', 'LOW']); poidsBot += 1; }
      if (window.outerWidth === 0 || window.outerHeight === 0) { signaux.push(['fenetre_sans_dimension', 'bot', 'MEDIUM']); poidsBot += 2; }
    });

    var interne = signaux.some(function (x) { return x[1] === 'interne'; });
    // Trois points suffisent quand ils viennent d'un signal fort ; il en faut
    // plusieurs faibles pour atteindre le meme niveau. Un visiteur presse qui
    // repart aussitot n'atteint jamais ce seuil : la vitesse n'est pas comptee.
    var confiance = poidsBot >= 3 ? 'HIGH' : (poidsBot === 2 ? 'MEDIUM' : (poidsBot === 1 ? 'LOW' : null));

    var type;
    if (interne) type = CATEGORIES.INTERNE;
    else if (confiance === 'HIGH' || confiance === 'MEDIUM') type = CATEGORIES.BOT;
    else if (confiance === 'LOW') type = CATEGORIES.INCERTAIN;
    else type = CATEGORIES.HUMAIN;

    return {
      type: type,
      bot_confidence: confiance,
      raisons: signaux.map(function (x) { return x[0]; }),
      // Le trafic interne et les bots averes sont ecartes. L'« incertain » est
      // conserve : un seul indice faible n'est pas une preuve, et l'ecarter
      // serait affirmer ce qu'on ne sait pas. Il reste identifiable par
      // traffic_type, donc isolable a la lecture ; ce qu'on refuse, c'est de
      // le faire disparaitre en silence. Un acheteur reel classe incertain
      // aurait autrement retire sa propre vente du chiffre d'affaires.
      include_in_business_metrics: type === CATEGORIES.HUMAIN || type === CATEGORIES.INCERTAIN,
    };
  }
  var TRAFIC = typeDeTrafic();

  /* ---------------------------------------------------------------------
     Consentement — Shopify est la seule autorité
     ---------------------------------------------------------------------
     On ne double pas la bannière et on ne contourne aucun refus. Trois états :
     inconnu (on attend), accordé (on écrit et on envoie), refusé (on jette). */

  var consentement = 'inconnu';
  var fileAvantConsentement = [];

  function appliquerConsentement(c) {
    var avant = consentement;
    if (!c) return;
    // « analytics » couvre la mesure. Sans lui, pas de mesure : c'est le sens
    // même de la case, et la contourner serait malhonnête.
    // Shopify expose DEUX formes selon la porte d'entree :
    //   currentVisitorConsent()      -> { analytics: 'yes' | 'no' | '' }
    //   evenement visitorConsentCollected -> { analyticsAllowed: true | false }
    // Ne lire que la premiere revenait a ignorer toute acceptation faite
    // pendant la visite : le consentement restait « inconnu » pour toujours.
    var brut = ('analyticsAllowed' in c) ? c.analyticsAllowed : c.analytics;
    var ok = brut === true || brut === 'yes';
    var non = brut === false || brut === 'no';
    consentement = ok ? 'accorde' : (non ? 'refuse' : 'inconnu');
    if (consentement === avant) return;
    trace('consentement :', consentement);
    if (consentement === 'accorde') { demarrer(); viderFile(); }
    if (consentement === 'refuse') { fileAvantConsentement = []; oublier(); }
  }

  function oublier() {
    // Un refus doit effacer ce que la mesure avait pu poser, pas seulement
    // arrêter d'écrire.
    ['tiloa_vid', 'tiloa_sid', 'tiloa_sid_ts', 'tiloa_first_touch', 'tiloa_last_touch'].forEach(LS.effacer);
  }

  function ecouterConsentement() {
    sansEchec(function () {
      document.addEventListener('visitorConsentCollected', function (e) {
        appliquerConsentement(e && e.detail);
      });
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err) { trace('API de consentement indisponible'); return; }
          sansEchec(function () {
            appliquerConsentement(window.Shopify.customerPrivacy.currentVisitorConsent());
          });
        });
      }
    });
  }

  /* ---------------------------------------------------------------------
     Identités anonymes
     ---------------------------------------------------------------------
     visiteur : persistant, pour distinguer nouveau et revenant.
     session  : 30 minutes d'inactivité, ou un changement de jour.
     Aucune empreinte de navigateur n'est calculée : ce serait du pistage
     clandestin, et c'est explicitement exclu. */

  var IDS = { visiteur: null, session: null, nouveauVisiteur: false, nouvelleSession: false };
  var DUREE_SESSION = 30 * 60 * 1000;

  function etablirIdentites() {
    var v = LS.lire('tiloa_vid');
    if (!v) { v = uuid(); IDS.nouveauVisiteur = true; LS.ecrire('tiloa_vid', v); }
    IDS.visiteur = v;

    var s = SS.lire('tiloa_sid');
    var dernier = parseInt(LS.lire('tiloa_sid_ts') || '0', 10);
    var expiree = !dernier || (Date.now() - dernier) > DUREE_SESSION;
    if (!s || expiree) { s = uuid(); IDS.nouvelleSession = true; SS.ecrire('tiloa_sid', s); }
    IDS.session = s;
    // L'identifiant de session est recopie dans localStorage : le Custom Pixel
    // du checkout s'execute dans un bac a sable sans acces au sessionStorage de
    // la boutique. Sans ce miroir, impossible de relier un achat a la visite.
    LS.ecrire('tiloa_sid', s);
    LS.ecrire('tiloa_sid_ts', String(Date.now()));
  }

  function prolongerSession() { LS.ecrire('tiloa_sid_ts', String(Date.now())); }

  /* ---------------------------------------------------------------------
     Attribution — premier contact et dernier contact
     ---------------------------------------------------------------------
     Le premier contact ne s'écrase jamais : il répond à « d'où cette personne
     nous connaît-elle ». Le dernier contact répond à « qu'est-ce qui l'a
     ramenée cette fois ». Persistance : 90 jours, choix documenté dans
     ANALYTICS.md. */

  var PARAMS_UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  /* Paramètres publicitaires.

     Les « p_… » sont notre convention Tiloa, remplis par les macros dynamiques
     de Pinterest ({campaignid}, {adgroupid}, {adid}…). Ils portent l'attribution
     au niveau de la créative, ce que ni le referrer ni les UTM seuls ne donnent.

     « pp » est ajouté par Pinterest lui-même, sans qu'on ait rien à faire :
     pp=0 pour un clic payant de premier ordre, pp=1 pour un clic gagné en aval,
     c'est-à-dire après que l'épingle a été enregistrée sur un tableau. Confondre
     les deux ferait payer au budget publicitaire des visites gratuites. */
  var PARAMS_PUB = ['epik', 'pp', 'gclid', 'fbclid', 'ttclid', 'msclkid', 'srsltid',
                    'p_campaign_id', 'p_campaign_name', 'p_adgroup_id', 'p_adgroup_name',
                    'p_ad_id', 'p_creative_id', 'p_device', 'p_product_id',
                    'pinterest_campaign_id', 'pinterest_ad_group_id', 'pinterest_ad_id',
                    'campaign_id', 'adgroup_id', 'ad_id', 'creative_id', 'funnel'];

  /* Nature d'une visite Pinterest. Quatre cas, jamais mélangés.

     PINTEREST_PAID    pp=0, ou un identifiant de campagne présent : clic payant.
     PINTEREST_EARNED  pp=1 : l'épingle a été enregistrée puis cliquée. Gratuit.
     PINTEREST_ORGANIC vient de Pinterest sans aucun marqueur publicitaire.
     PINTEREST_UNKNOWN vient de Pinterest, marqueurs contradictoires ou illisibles.

     On ne devine pas : sans signal, une visite Pinterest est organique, pas
     payante. Compter une visite gratuite dans le coût d'acquisition fausserait
     tout le calcul de rentabilité. */
  function naturePinterest(p, source) {
    if (source !== 'pinterest') return null;
    var aIdPub = !!(p.p_campaign_id || p.p_ad_id || p.p_creative_id || p.p_adgroup_id);
    var pp = p.pp;
    if (pp === '0') return 'PINTEREST_PAID';
    if (pp === '1') return 'PINTEREST_EARNED';
    if (aIdPub) return 'PINTEREST_PAID';
    if (pp === undefined || pp === null || pp === '') return 'PINTEREST_ORGANIC';
    return 'PINTEREST_UNKNOWN';
  }
  var RETENTION_TOUCH = 90 * 24 * 60 * 60 * 1000;

  function lireParametres() {
    var p = {};
    sansEchec(function () {
      var q = new URLSearchParams(window.location.search);
      PARAMS_UTM.concat(PARAMS_PUB).forEach(function (k) {
        var v = q.get(k);
        if (v) p[k] = String(v).slice(0, 200);
      });
    });
    return p;
  }

  function sourceDeduite(p) {
    if (p.utm_source) return String(p.utm_source).toLowerCase();
    if (p.epik || p.pinterest_ad_id) return 'pinterest';
    var r = sansEchec(function () { return document.referrer ? new URL(document.referrer).hostname : ''; }, '');
    if (!r) return 'direct';
    if (/tiloa\.fr$/.test(r)) return null; // navigation interne : on ne touche à rien
    if (/pinterest\./i.test(r)) return 'pinterest';
    if (/google\./i.test(r)) return 'google';
    if (/facebook\.|instagram\./i.test(r)) return 'meta';
    return r;
  }

  var ATTRIB = { premier: null, dernier: null };

  function etablirAttribution() {
    var p = lireParametres();
    var src = sourceDeduite(p);

    sansEchec(function () {
      var brut = LS.lire('tiloa_first_touch');
      if (brut) {
        var f = JSON.parse(brut);
        if (f && f.ts && (Date.now() - f.ts) < RETENTION_TOUCH) ATTRIB.premier = f;
      }
    });

    // On ne crée un nouveau contact que si quelque chose d'extérieur l'annonce.
    // Une navigation interne ne doit jamais réécrire l'attribution.
    var contact = null;
    if (src) {
      contact = {
        ts: Date.now(),
        source: src,
        medium: p.utm_medium || (src === 'direct' ? 'none' : 'referral'),
        campaign: p.utm_campaign || null,
        content: p.utm_content || null,
        term: p.utm_term || null,
        landing_page: sansEchec(function () { return window.location.pathname; }, null),
        pinterest_nature: naturePinterest(p, src),
        params: p,
      };
    }

    if (contact && !ATTRIB.premier) {
      ATTRIB.premier = contact;
      LS.ecrire('tiloa_first_touch', JSON.stringify(contact));
    }
    if (contact) {
      ATTRIB.dernier = contact;
      LS.ecrire('tiloa_last_touch', JSON.stringify(contact));
    } else {
      sansEchec(function () {
        var b = LS.lire('tiloa_last_touch');
        if (b) ATTRIB.dernier = JSON.parse(b);
      });
    }
  }

  /* ---------------------------------------------------------------------
     Contexte de page
     --------------------------------------------------------------------- */

  function typeDePage() {
    var d = sansEchec(function () { return document.body.getAttribute('data-tiloa-page-type'); }, null);
    if (d) return d;
    var p = window.location.pathname;
    if (p === '/' ) return 'home';
    if (/^\/products\//.test(p)) return 'product';
    if (/^\/collections\//.test(p)) return 'collection';
    if (/^\/cart/.test(p)) return 'cart';
    if (/^\/pages\//.test(p)) return 'page';
    if (/^\/search/.test(p)) return 'search';
    if (/^\/blogs\//.test(p)) return 'blog';
    return 'autre';
  }

  function contextePage() {
    var m = sansEchec(function () { return window.TILOA_ANALYTICS_PAGE || {}; }, {}) || {};
    return {
      page_url: sansEchec(function () { return window.location.href.slice(0, 500); }, null),
      page_path: sansEchec(function () { return window.location.pathname; }, null),
      page_title: sansEchec(function () { return document.title.slice(0, 200); }, null),
      page_type: typeDePage(),
      template: m.template || null,
      referrer: sansEchec(function () { return document.referrer ? document.referrer.slice(0, 300) : null; }, null),
      previous_page: SS.lire('tiloa_prev') || null,
      product_id: m.product_id || null,
      product_handle: m.product_handle || null,
      variant_id: m.variant_id || null,
      currency: m.currency || null,
    };
  }

  function contexteAppareil() {
    return sansEchec(function () {
      var l = Math.max(window.innerWidth || 0, 0);
      return {
        device_type: l < 768 ? 'mobile' : (l < 1024 ? 'tablet' : 'desktop'),
        screen_size: (window.screen ? window.screen.width + 'x' + window.screen.height : null),
        viewport: l + 'x' + (window.innerHeight || 0),
        language: (navigator.language || '').slice(0, 10),
      };
    }, {});
  }

  /* ---------------------------------------------------------------------
     File d'envoi
     ---------------------------------------------------------------------
     Les événements partent groupés, jamais un par un, et jamais de façon
     bloquante. sendBeacon quand le navigateur s'en va, fetch keepalive sinon.
     Sans ENDPOINT configuré : la file reste en mémoire et rien ne sort. */

  var file = [];
  var envoyes = {};       // event_id déjà partis : garde-fou contre les doublons
  var minuteurEnvoi = null;
  var MAX_FILE = 60;

  function viderFile() {
    if (consentement !== 'accorde') return;
    if (!file.length) return;
    var lot = file.splice(0, file.length);
    if (!ENDPOINT) { trace('aucun point de collecte configuré — ' + lot.length + ' événement(s) non envoyés'); return; }
    var corps = JSON.stringify({ v: VERSION, site: 'tiloa', events: lot });
    // Le type doit rester « text/plain » : c'est l'un des rares types que CORS
    // laisse passer sans requête préalable. Avec « application/json », le
    // navigateur envoie un préflight, et une balise beacon préflightée est
    // abandonnée en silence — sendBeacon renvoie quand même true, si bien que
    // l'on croit avoir envoyé alors que rien n'arrive. Le collecteur lit le
    // corps brut et ne regarde pas ce type, donc rien d'autre ne change.
    var parti = sansEchec(function () {
      if (navigator.sendBeacon) {
        return navigator.sendBeacon(ENDPOINT, new Blob([corps], { type: 'text/plain;charset=UTF-8' }));
      }
      return false;
    }, false);
    if (!parti) {
      sansEchec(function () {
        window.fetch(ENDPOINT, {
          method: 'POST', keepalive: true, mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: corps,
        }).catch(function () {});
      });
    }
    trace('envoi de ' + lot.length + ' événement(s)');
  }

  function planifierEnvoi() {
    if (minuteurEnvoi) return;
    minuteurEnvoi = window.setTimeout(function () { minuteurEnvoi = null; viderFile(); }, 1200);
  }

  /* ---------------------------------------------------------------------
     Émission d'un événement
     --------------------------------------------------------------------- */

  function emettre(nom, donnees, options) {
    try {
      var opt = options || {};
      // Déduplication : une clé stable empêche qu'un rafraîchissement ou un
      // second écouteur compte deux fois la même action.
      var cle = opt.dedup_key ? (nom + ':' + opt.dedup_key) : null;
      if (cle) {
        if (envoyes[cle]) { trace('doublon ignoré :', nom, opt.dedup_key); return null; }
        envoyes[cle] = true;
        sansEchec(function () {
          var vus = JSON.parse(SS.lire('tiloa_dedup') || '{}');
          if (vus[cle]) { throw new Error('deja'); }
          vus[cle] = 1; SS.ecrire('tiloa_dedup', JSON.stringify(vus));
        });
      }

      var ev = {
        event_id: uuid(),
        event_name: nom,
        timestamp: new Date().toISOString(),
        ts_ms: Date.now(),
        session_id: IDS.session,
        anonymous_visitor_id: IDS.visiteur,
        new_visitor: IDS.nouveauVisiteur,
        new_session: IDS.nouvelleSession,
        traffic_type: TRAFIC.type,
        traffic_flags: TRAFIC.raisons,
        bot_confidence: TRAFIC.bot_confidence,
        include_in_business_metrics: TRAFIC.include_in_business_metrics,
        analytics_version: VERSION,
      };

      var c = contextePage();
      for (var k in c) if (c[k] !== null && c[k] !== undefined) ev[k] = c[k];
      var d = contexteAppareil();
      for (var k2 in d) ev[k2] = d[k2];

      if (ATTRIB.premier) {
        ev.first_touch_source = ATTRIB.premier.source;
        ev.first_touch_campaign = ATTRIB.premier.campaign;
        ev.first_touch_content = ATTRIB.premier.content;
        ev.first_touch_landing_page = ATTRIB.premier.landing_page;
        ev.first_touch_ts = ATTRIB.premier.ts;
      }
      if (ATTRIB.dernier) {
        ev.last_touch_source = ATTRIB.dernier.source;
        ev.last_touch_campaign = ATTRIB.dernier.campaign;
        ev.last_touch_content = ATTRIB.dernier.content;
        var p = ATTRIB.dernier.params || {};
        PARAMS_UTM.forEach(function (k3) { if (p[k3]) ev[k3] = p[k3]; });
        PARAMS_PUB.forEach(function (k4) { if (p[k4]) ev[k4] = p[k4]; });
        // La nature du clic voyage avec chaque événement : sans elle, on ne
        // pourrait plus dire, au moment de l'achat, si la visite était payante.
        if (ATTRIB.dernier.pinterest_nature) ev.pinterest_nature = ATTRIB.dernier.pinterest_nature;
      }

      if (donnees) for (var k5 in donnees) if (donnees[k5] !== undefined) ev[k5] = donnees[k5];

      trace(nom, ev);
      prolongerSession();

      if (consentement !== 'accorde') {
        // On garde en mémoire, sans rien écrire sur le poste. Si la personne
        // refuse, cette file est jetée telle quelle.
        if (fileAvantConsentement.length < MAX_FILE) fileAvantConsentement.push(ev);
        return ev.event_id;
      }

      if (file.length < MAX_FILE) file.push(ev);
      planifierEnvoi();
      versClarity(nom, ev);
      return ev.event_id;
    } catch (e) {
      // Une erreur de mesure ne doit jamais remonter jusqu'à l'interface.
      trace('erreur ignorée', e && e.message);
      return null;
    }
  }

  /* ---------------------------------------------------------------------
     Pont vers Microsoft Clarity
     ---------------------------------------------------------------------
     Clarity sert au comportement (enregistrements, cartes de chaleur). On lui
     pose des étiquettes pour pouvoir filtrer les sessions par publicité, et on
     lui signale les événements marquants. Aucune donnée personnelle. */

  var clarityEtiquete = false;

  function versClarity(nom, ev) {
    sansEchec(function () {
      if (typeof window.clarity !== 'function') return;
      if (!clarityEtiquete) {
        clarityEtiquete = true;
        var tags = {
          traffic_type: TRAFIC.type,
          page_type: ev.page_type,
          session_id: IDS.session,
          first_touch_source: ev.first_touch_source,
          last_touch_source: ev.last_touch_source,
          campaign: ev.utm_campaign,
          ad: ev.utm_content,
          landing_page: ATTRIB.premier ? ATTRIB.premier.landing_page : null,
          funnel: ev.funnel,
        };
        for (var k in tags) if (tags[k]) window.clarity('set', k, String(tags[k]).slice(0, 100));
      }
      // Seuls les événements décisifs, pour ne pas noyer Clarity.
      if (/^(product_view|cta_click|add_to_cart|cart_view|checkout_started|purchase)$/.test(nom)) {
        window.clarity('event', nom);
      }
    });
  }

  /* ---------------------------------------------------------------------
     Observateurs
     --------------------------------------------------------------------- */

  var demarre = false;
  var tDebut = Date.now();
  var tActif = 0;
  var dernierTic = Date.now();
  var premierClicFait = false;

  function compterTempsActif() {
    var n = Date.now();
    if (!document.hidden) tActif += Math.min(n - dernierTic, 5000);
    dernierTic = n;
  }

  function demarrer() {
    if (demarre) return;
    demarre = true;

    etablirIdentites();
    etablirAttribution();

    emettre('page_view', {}, { dedup_key: IDS.session + ':' + window.location.pathname + ':' + Math.floor(tDebut / 1000) });
    sansEchec(function () { SS.ecrire('tiloa_prev', window.location.pathname); });

    if (typeDePage() === 'product') {
      emettre('product_view', {}, { dedup_key: IDS.session + ':' + (contextePage().product_id || window.location.pathname) });
    }
    if (typeDePage() === 'cart') emettre('cart_view', {});

    observerScroll();
    observerSections();
    observerClics();
    observerPanier();
    observerFinDePage();
    window.setInterval(compterTempsActif, 1000);
  }

  /* ---- défilement : chaque seuil une seule fois par page ---- */
  function observerScroll() {
    var seuils = [25, 50, 75, 90, 100];
    var atteints = {};
    var enAttente = false;
    function mesurer() {
      enAttente = false;
      sansEchec(function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h <= 0) return;
        var pct = Math.min(100, Math.round((window.scrollY / h) * 100));
        for (var i = 0; i < seuils.length; i++) {
          var s = seuils[i];
          if (pct >= s && !atteints[s]) {
            atteints[s] = true;
            emettre('scroll_depth', { scroll_percent: s, time_to_scroll_ms: Date.now() - tDebut },
                    { dedup_key: IDS.session + ':' + window.location.pathname + ':' + s });
          }
        }
      });
    }
    window.addEventListener('scroll', function () {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(mesurer);
    }, { passive: true });
    mesurer();
  }

  /* ---- clics : seulement ce qui sert à comprendre une conversion ----
     On écoute en phase de bulle et on ne préempte jamais le geste : le bouton
     fait son travail, la mesure se contente de regarder. */
  function observerClics() {
    document.addEventListener('click', function (e) {
      sansEchec(function () {
        // Un bouton relais (barre collante, CTA final) déclenche le vrai
        // bouton d'achat par programme : seul le bouton touché est compté.
        if (e.target && e.target.closest && e.target.closest('[data-tiloa-relay]')) return;
        var cible = e.target && e.target.closest
          ? e.target.closest('[data-analytics-id], a[href], button')
          : null;
        if (!cible) return;

        var id = cible.getAttribute('data-analytics-id');
        var section = cible.getAttribute('data-analytics-section');
        var action = cible.getAttribute('data-analytics-action');

        // Sans étiquette explicite, on ne retient que ce qui a un sens
        // marketing : les liens vers un produit, le panier ou le checkout.
        var href = cible.getAttribute('href') || '';
        if (!id) {
          var interessant = /\/(products|cart|checkout|pages)\//.test(href) ||
                            /product-form__submit|tiloa-sticky|gp-cta/.test(cible.className || '');
          if (!interessant) return;
        }

        if (!premierClicFait) {
          premierClicFait = true;
          emettre('first_click', { time_to_first_click_ms: Date.now() - tDebut });
        }

        emettre('cta_click', {
          analytics_id: id || null,
          analytics_section: section || null,
          analytics_action: action || null,
          element_tag: cible.tagName.toLowerCase(),
          element_text: ((cible.innerText || '').trim() || cible.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 80),
          destination: href ? href.slice(0, 300) : null,
        });
      });
      // Phase de capture : le libellé est lu avant que le bouton touché ne le
      // remplace (« Ajout… ») ; le clic relayé vers le bouton principal porte
      // déjà data-tiloa-relay et reste ignoré.
    }, { passive: true, capture: true });
  }

  /* ---- panier : on écoute les réponses de Shopify, on n'invente rien ----
     Envelopper fetch est la seule façon fiable de voir un ajout au panier quel
     que soit le thème. L'enveloppe est transparente : elle rend exactement la
     promesse d'origine, et une erreur de mesure ne casse pas l'appel. */
  function observerPanier() {
    sansEchec(function () {
      var fetchOrigine = window.fetch;
      if (!fetchOrigine) return;
      window.fetch = function (entree, init) {
        var promesse = fetchOrigine.apply(this, arguments);
        try {
          var url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
          if (/\/cart\/add(\.js)?/.test(url)) {
            // Quantité réellement envoyée : la réponse donne la ligne entière,
            // qui cumule les ajouts précédents du même article.
            var qEnv = null;
            // Ajout de plusieurs articles (lot de couleurs mélangées) : quantité envoyée PAR variante,
            // sinon la quantité du 1er article était appliquée à tous (21/10/2026).
            var qParVariante = null;
            try {
              var corps = init && init.body;
              if (corps && typeof corps.get === 'function') qEnv = parseInt(corps.get('quantity'), 10) || null;
              else if (typeof corps === 'string') {
                var jb = JSON.parse(corps);
                qEnv = jb.quantity || (jb.items && jb.items[0] && jb.items[0].quantity) || null;
                if (jb.items && jb.items.length > 1) {
                  // Une variante présente deux fois : correspondance ambiguë, ancien calcul conservé.
                  qParVariante = {};
                  var doublon = false;
                  jb.items.forEach(function (it) {
                    var vid = it && parseInt(it.id, 10);
                    if (!vid) return;
                    if (qParVariante[vid]) doublon = true;
                    qParVariante[vid] = parseInt(it.quantity, 10) || 1;
                  });
                  if (doublon) qParVariante = null;
                }
              }
            } catch (e3) { qEnv = null; qParVariante = null; }
            promesse.then(function (rep) {
              try {
                if (!rep || !rep.ok) return;
                rep.clone().json().then(function (data) {
                  var articles = (data && data.items) ? data.items : [data];
                  articles.forEach(function (a) {
                    if (!a || !a.id) return;
                    var qA = qEnv;
                    if (qParVariante) {
                      var qv = qParVariante[parseInt(a.variant_id || a.id, 10)];
                      if (qv) qA = qv;
                    }
                    emettre('add_to_cart', {
                      variant_id: a.id,
                      product_id: a.product_id || null,
                      product_handle: a.handle || null,
                      quantity: qA || a.quantity || 1,
                      value: (a.final_line_price != null
                        ? (qA && a.quantity ? Math.round(a.final_line_price * qA / a.quantity) / 100 : a.final_line_price / 100)
                        : null),
                      line_quantity: a.quantity || null,
                      currency: contextePage().currency,
                      time_to_atc_ms: Date.now() - tDebut,
                    });
                  });
                }).catch(function () {});
              } catch (e2) {}
            }).catch(function () {});
          }
        } catch (e) { /* la mesure échoue, la requête continue */ }
        return promesse;
      };
    });
  }

  /* ---- sections de page : ou les gens s'arretent de descendre ----
     Le defilement en pourcentage dit « ils sont partis a 60 % ». Il ne dit pas
     ce qu'il y avait a 60 %, et 60 % d'une page longue n'est pas 60 % d'une
     page courte. Une section nommee repond a la vraie question : « ils ne
     voient jamais les avis ».

     Une section compte pour atteinte quand la moitie de sa hauteur est restee
     visible une seconde pleine. Le seuil d'une seconde ecarte le defilement
     rapide : traverser un bloc en trombe n'est pas le lire. */
  /* « shopify-section-template--17384__reviews » doit se lire « reviews ».
     Le prefixe de gabarit change a chaque duplication de theme : le garder
     ferait apparaitre la meme section sous deux noms differents apres une
     simple copie, et les comparaisons avant/apres seraient perdues. */
  function nomDeSection(el) {
    var explicite = el.getAttribute('data-tiloa-section') || el.getAttribute('data-analytics-section');
    if (explicite) return explicite.slice(0, 60);
    var id = el.id || '';
    if (id.indexOf('shopify-section-') !== 0) return null;
    // Deux prefixes possibles : « template--<id>__ » pour un gabarit,
    // « sections--<id>__ » pour un groupe (en-tete, pied de page).
    return id.replace(/^shopify-section-/, '')
             .replace(/^(template|sections)--\d+__/, '')
             .slice(0, 60) || null;
  }

  function observerSections() {
    sansEchec(function () {
      if (!window.IntersectionObserver) return;
      /* Shopify enveloppe deja chaque bloc d'un gabarit dans un conteneur
         « shopify-section-<cle> », ou la cle est celle du fichier JSON :
         main, steps, reviews, faq, packaging... Ce sont exactement les noms
         qu'on veut lire dans un rapport, et ils sont deja la.

         On s'en sert donc au lieu d'aller baliser une trentaine de fichiers
         liquid a la main : moins de code a maintenir, aucune section oubliee,
         et toute section ajoutee plus tard est suivie sans rien faire. Un
         attribut explicite reste prioritaire quand on veut un autre nom. */
      // Les boutons portent aussi data-analytics-section (pour le rapport des
      // clics) : ce ne sont pas des sections, on ne compte pas leurs « vues ».
      var blocs = Array.prototype.filter.call(document.querySelectorAll(
        '[data-tiloa-section], [data-analytics-section], [id^="shopify-section-"]'),
        function (el) { return !el.matches('a, button, input, label'); });
      if (!blocs.length) return;

      var vues = {};
      var minuteurs = {};
      var ordre = 0;

      var obs = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          var el = e.target;
          var nom = nomDeSection(el);
          if (!nom || vues[nom]) return;

          var hRoot = e.rootBounds ? e.rootBounds.height : window.innerHeight;
          var vue = e.isIntersecting && e.boundingClientRect.height > 0 &&
            (e.intersectionRatio >= 0.5 || e.intersectionRect.height >= hRoot * 0.5);
          if (vue) {
            if (minuteurs[nom]) return;
            minuteurs[nom] = setTimeout(function () {
              if (vues[nom]) return;
              vues[nom] = true;
              emettre('section_view', {
                analytics_section: nom,
                analytics_id: el.id || null,
                // Le rang dit si la section a ete atteinte tot ou tard, ce que
                // le seul nom ne dit pas quand l'ordre des blocs change.
                section_rank: ++ordre,
                time_to_section_ms: Date.now() - tDebut,
              }, { dedup_key: IDS.session + ':sec:' + window.location.pathname + ':' + nom });
            }, 1000);
          } else {
            clearTimeout(minuteurs[nom]);
            minuteurs[nom] = null;
          }
        });
      }, { threshold: [0, 0.25, 0.5] });

      for (var i = 0; i < blocs.length; i++) obs.observe(blocs[i]);

      document.addEventListener('change', function (ev) {
        sansEchec(function () {
          var r = ev.target;
          if (!r || !r.matches || !r.matches('[data-tiloa-bundle] input[type="radio"]')) return;
          var qte = parseInt(r.value, 10) || null;
          emettre('offer_select', { quantity: qte, analytics_section: 'buybox', analytics_action: 'offer_select' });
        });
      }, { passive: true });

      // Un clic dans une section porte le nom de cette section, meme quand
      // l'element clique ne l'annonce pas lui-meme.
      document.addEventListener('click', function (ev) {
        sansEchec(function () {
          if (ev.target && ev.target.closest && ev.target.closest('[data-tiloa-relay]')) return;
          // Cliquer un <label> déclenche un second clic sur son <input> :
          // on ne compte que le premier.
          if (ev.target && ev.target.matches && ev.target.matches('label input')) return;
          var el = ev.target && ev.target.closest
            ? ev.target.closest('[data-tiloa-section], [data-analytics-section], [id^="shopify-section-"]') : null;
          if (!el) return;
          var nom = nomDeSection(el);
          if (!nom) return;
          emettre('section_click', { analytics_section: nom });
        });
      }, { passive: true });
    });
  }

  /* ---- fin de page : on solde le temps passé et on vide la file ---- */
  function observerFinDePage() {
    function solder() {
      compterTempsActif();
      emettre('page_leave', {
        time_total_ms: Date.now() - tDebut,
        time_active_ms: tActif,
      }, { dedup_key: IDS.session + ':leave:' + window.location.pathname + ':' + tDebut });
      viderFile();
    }
    document.addEventListener('visibilitychange', function () {
      compterTempsActif();
      if (document.hidden) { solder(); }
    });
    window.addEventListener('pagehide', solder);
  }

  /* ---------------------------------------------------------------------
     Interface publique — utilisée par le Custom Pixel et par le thème
     --------------------------------------------------------------------- */

  window.TiloaAnalytics = {
    version: VERSION,
    track: function (nom, donnees, options) { return emettre(nom, donnees, options); },
    ids: function () { return { visitor: IDS.visiteur, session: IDS.session }; },
    attribution: function () { return { first: ATTRIB.premier, last: ATTRIB.dernier }; },
    consent: function () { return consentement; },
    traffic: function () { return TRAFIC; },
    flush: viderFile,
    // Bascule manuelle, equivalente a ?tiloa_test=1 / ?tiloa_test=0
    setTest: function (on) {
      sansEchec(function () {
        if (on) window.localStorage.setItem('tiloa_internal_test', '1');
        else window.localStorage.removeItem('tiloa_internal_test');
      });
      return on ? 'mode test ACTIF sur ce navigateur' : 'mode test leve';
    },
    debug: function (on) {
      DEBUG = !!on;
      sansEchec(function () { window.sessionStorage.setItem('tiloa_debug', on ? '1' : '0'); });
      return DEBUG;
    },
  };

  ecouterConsentement();
  trace('chargé — version ' + VERSION + (ENDPOINT ? '' : ' — aucun point de collecte configuré'));
})();
